"use client";

import { useMemo, type ReactNode } from "react";
import { useTranslations } from "next-intl";

const richTextTags = {
  strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
};

export function useGuidedPathResultsMessages() {
  const t = useTranslations("GuidedPath.results");

  return useMemo(
    () => ({
      personalizing: t("personalizing"),
      noResultsTitle: t("noResultsTitle"),
      noResultsDescription: t("noResultsDescription"),
      startOver: t("startOver"),
      editGoal: t("editGoal"),
      exploreOptions: t("exploreOptions"),
      aiIconAlt: t("aiIconAlt"),
      recommendedPathsTitle: (goal: string) =>
        t.rich("recommendedPathsTitle", { goal, ...richTextTags }),
      personalizedDescription: (
        careerStage: string,
        skills: string,
        goal: string,
      ) =>
        t.rich("personalizedDescription", {
          careerStage,
          skills,
          goal,
          ...richTextTags,
        }),
      fallbackDescription: (goal: string) =>
        t.rich("fallbackDescription", { goal, ...richTextTags }),
      careerStageArticleAn: t("careerStageArticleAn"),
      careerStageArticleA: t("careerStageArticleA"),
      defaultGoalMessage: t("defaultGoalMessage"),
    }),
    [t],
  );
}
